<template>
    <div>
        <multiselect class="form-control" v-model="modelo.idempresa" :options="datos" track-by="id" label="nombre" 
        :searchable="true" :close-on-select="true" :show-labels="false" placeholder="Seleccione..."></multiselect>
    </div>
</template>

<script>
import gql from 'graphql-tag'
import {parseJsonError} from '@/components/Utils.js'
export default {
    props:{ model:Object,default:{type:Object,required:false,default:null} },
    data(){
        return{
            datos: [],
            modelo: {
                idempresa: null,
            }
        }
    },
    watch:{
        'modelo.idempresa': function(){this.model.idempresa=this.modelo.idempresa; },
        'default':function(a){
            if( a == null ) return;
            this.modelo.idempresa = a;
        },
    },
    methods:{
        async getDatos() {
            var vue = this;
            var sql = gql`query{getEmpresas{id,nombre}}`;
            await this.$apollo.query({
            query: sql,
            }).then((data) => {
                vue.datos = data.data.getEmpresas;
                if( this.default ){
                    this.modelo.idempresa = this.datos.find( x => x.id == this.default.id );
                }
            }).catch((error) => {
                window.console.error(error)
                this.$notify( parseJsonError( error,'getEmpresas' ) )
            })
        },
    },
    mounted(){
        this.getDatos();
    }
}
</script>